import React from 'react';
import Select from "./Select";
import {useTranslation} from "react-i18next";

const SegmentVisibleSelector = ({value, setValue, disabled, required}) => {
    const {t} = useTranslation();

    return <Select
        label={t('segment_visible')}
        value={value}
        onChange={e => setValue(e.target.value)}
        optionKey='Key'
        optionValue='Value'
        allowEmpty={false}
        options={[
            {Key: 'Y', Value: t('segment_visible_y')},
            {Key: 'N', Value: t('segment_visible_n')},
        ]}
        inputProps={{
            disabled: disabled,
            variant: 'outlined',
            fullWidth: true,
            required: required
        }}
    />;
};

export default SegmentVisibleSelector;